export const CONTEXT_LIST = ["Maintenance", "DLP", "Optimisation", "Other"];

export const RESPONSIBLE_LIST = [
  "ConserveIt",
  "Site Local",
  "Site National",
  "Mech. Contractor",
  "BMS Contractor",
  "Other Contractor",
  "InSite Engineer",
  "Monitoring",
];

/**
 * Woolworth specific responsibilities list
 */
export const WW_RESPONSIBLE_LIST = [
  "Asset Team - Building",
  "Asset Team - Electrical",
  "Asset Team - Plumbing",
  "Asset Team - Refrigeration",
  "EMC - Energy Optimisation Specialist",
  "EMC - Operations/IT",
  "External Contractors (Back to Back)",
  "External Contractors (Others)",
  "Field Maintenance Technician (FMT) - HVAC",
  "Field Maintenance Technician (FMT) - Refrigeration",
  "Service Team (STL)",
  "State Admin Manager (SAM)",
  "Technical Support Team (TST)",
  "WFM Support Centre",
  "Other",
  "ConserveIt",
];

export const PRIORITY_LIST = [
  "Blocker",
  "Critical",
  "Major",
  "Moderate",
  "Minor",
  "Trivial",
];

export const TRANSITION_REASON_LIST = [
  // Closed
  "Fixed",
  "False alert",
  "Cannot fix (known issue)",
  "Duplicate",
  // parked
  "Too difficult/expensive",
  "Low priority",
  "Other",
  "Rejected",
];

/**
 * Status only applicable to creation and can be changed later
 */
export const STATUS_LIST = [
  "Open",
  "To Be Raised MM",
  "Work in progress",
  "Scope Required",
  "To be quoted",
  "Pending PO",
  "In Review",
  "Parked",
  "Closed",
  "Rejected",
];
